module.exports = __webpack_public_path__ + "static/media/end-image.adb17d4e.svg";